<template>
  <div class="catalog-form">
    <v-alert type="info">
      Le catalogue peut être utilisé pour afficher les tarifs si le paiement par
      CB n'est pas activé.
    </v-alert>
    <v-row>
      <v-col cols="12">
        <v-select
          v-model="parentCatalogForm.catalogType"
          label="Type de catalogue"
          :items="catalogTypesChoice"
          item-value="value"
          item-text="text"
          :rules="rules.catalog_typeRules"
          hint="Spécifier le type de catalogue"
          persistent-hint
          @input="parentCatalogForm.cardModel = -1"
        ></v-select>
      </v-col>
      <v-col cols="12" md="5" class="py-0">
        <v-select
          v-model="parentCatalogForm.mode"
          label="Mode"
          :items="modesChoice"
          item-value="value"
          item-text="text"
          :rules="rules.modeRules"
        ></v-select>
      </v-col>
      <v-col cols="12" md="4" class="py-0">
        <v-text-field
          v-model="parentCatalogForm.price"
          :rules="rules.priceRules"
          label="Prix de vente (TTC) :"
          hint="Prix TTC proposé aux utilisateurs finaux"
          persistent-hint
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="3" class="pt-0">
        <v-select
          v-model="parentCatalogForm.currency"
          label="Devise"
          :items="currenciesChoice"
          hint="Devise compatible avec les portails"
          persistent-hint
        ></v-select>
      </v-col>
      <v-col cols="12" md="5" class="align-self-center text-center">
        <v-btn color="#fec40d" dark @click.stop="chooseModel">
          Choisir un modèle
        </v-btn>
      </v-col>
      <v-col cols="12" md="7" class="align-self-center text-center">
        <v-text-field
          :rules="rules.card_modelRules"
          label=""
          readonly
          :value="selectedModelText"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="6" class="pt-0">
        <v-select
          v-model="parentCatalogForm.reversionType"
          label="Type de reversion"
          :items="reversionTypesChoice"
          item-value="value"
          item-text="text"
          hide-details
        ></v-select>
      </v-col>
      <v-col cols="12" md="6" class="pt-0">
        <v-text-field
          v-model="parentCatalogForm.reversion"
          label="Montant"
          :rules="rules.reversionRules"
          hint="Montant reversé à l'hôtel"
          persistent-hint
        ></v-text-field>
      </v-col>
      <v-col cols="12" class="pt-0">
        <v-text-field
          v-model="parentCatalogForm.externalReference"
          label="Reference externe (optional)"
          hint="Code produit"
          persistent-hint
        ></v-text-field>
      </v-col>
    </v-row>

    <card-model-chooser
      :open.sync="openModelPickerDialog"
      :selectedModelId.sync="parentCatalogForm.cardModel"
      :cardModels="filteredCardModels"
    ></card-model-chooser>
  </div>
</template>
<script>
import { computed, ref } from "@vue/composition-api";
import CardModelChooser from "./CardModelChooser.vue";

export default {
  components: {
    CardModelChooser,
  },
  props: {
    catalogForm: Object,
    cardModels: Array,
    currenciesChoice: Array,
    catalogTypesChoice: Array,
    modesChoice: Array,
    reversionTypesChoice: Array,
    rules: Object,
  },
  setup(props, { emit }) {
    /* Variables */
    const openModelPickerDialog = ref(false);
    const filteredCardModels = ref([]);

    /* Computed */
    const parentCatalogForm = computed({
      get: () => props.catalogForm,
      set: (value) => {
        emit("update:catalogForm", value);
      },
    });

    const selectedModel = computed(function () {
      return props.cardModels.filter(
        (model) => model.id === parentCatalogForm.value.cardModel
      )[0];
    });

    const selectedModelText = computed(function () {
      if (!selectedModel.value) {
        return "Aucun modèle sélectionné";
      } else {
        return selectedModel.value.id + " - " + selectedModel.value.description;
      }
    });

    /* Méthodes */
    const chooseModel = function () {
      filteredCardModels.value = [];
      if (parentCatalogForm.value.catalogType === undefined) {
        alert("choississez un type de catalogue d'abord");
        return;
      }
      if (
        parentCatalogForm.value.catalogType === 1 ||
        parentCatalogForm.value.catalogType === 3
      ) {
        // cb ou employés
        filteredCardModels.value = props.cardModels.filter(
          (model) => model.cardOrigin.id === 2
        );
      } else if (parentCatalogForm.value.catalogType === 2) {
        // eticketing
        filteredCardModels.value = props.cardModels.filter(
          (model) => model.cardOrigin.id === 4
        );
      } else if (parentCatalogForm.value.catalogType === 4) {
        // prevente
        filteredCardModels.value = props.cardModels.filter(
          (model) => model.cardOrigin.id === 7
        );
      }
      openModelPickerDialog.value = true;
    };
    return {
      parentCatalogForm,
      openModelPickerDialog,
      selectedModel,
      chooseModel,
      filteredCardModels,
      selectedModelText,
    };
  },
};
</script>
